import React, { useState } from "react";
import { configFile } from "@/config";
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Collapse,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import Image from "next/image";

import HeaderModal from "@/components/HeaderModal";

interface Props {
  submenu: any;
}

export default function DesktopNavSubmenu({ submenu }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [menuId, setMenuId] = useState<number | undefined>();

  const handleMouseOver = (index: number) => {
    setMenuId(index);
    onOpen();
  };

  const handleMouseOut = () => {
    onClose();
  };
  
  return (
    <Flex
      alignItems="flex-start"
      display={{ base: "none", lg: "flex" }}
      maxWidth="1216px"
      margin="0 auto"
      gap="10px"
      onMouseLeave={() => handleMouseOut()}
    >
      {submenu.length > 0 &&
        submenu.map((item: any, index: number) => (
          <Box border="none" key={item.id}>
            <Flex>
              <Button
                aria-label="button menu"
                onMouseEnter={() => handleMouseOver(index)}
                bgColor="transparent"
                height="80px"
                minW="168px"
                alignItems="center"
                justifyContent="space-between"
                fontSize="md"
                lineHeight="6"
                fontWeight="semibold"
                color="gray.600"
                cursor="pointer"
                borderBottom="5px solid transparent"
                _hover={{
                  bgColor: "none",
                  color: "gray.600",
                  borderColor: configFile.primaryAccentColor,
                }}
                _expanded={{
                  color: "gray.600",
                  borderColor: configFile.primaryAccentColor,
                }}
              >
                <Flex gap="11px">
                  <Image
                    src={item.icon.data.attributes.url}
                    width={item.icon.data.attributes.width}
                    height={item.icon.data.attributes.height}
                    alt="icon menu"
                  />
                  {item.title}
                </Flex>
                <ChevronDownIcon ml="18px" />
              </Button>
              <Collapse in={isOpen} animateOpacity>
                {menuId !== undefined && index === menuId && (
                  <Box
                    position="absolute"
                    left="0"
                    right="0"
                    margin="80px auto"
                    w="100%"
                    maxWidth="1216px"
                    backgroundColor="#FFFFFF"
                    padding={{ base: "40px 0px 30px 0px", md: "24px" }}
                    boxShadow="xl"
                    borderBottomRadius="12px"
                    height="23.5rem"
                  >
                    <HeaderModal
                      articles={item.post_component}
                      breeds={item.breed_component}
                      category={item.category_component}
                    />
                  </Box>
                )}
              </Collapse>
            </Flex>
          </Box>
        ))}
    </Flex>
  );
}
